import Vue from 'vue'

import { Toast, NavBar, Empty, Icon, Row, Col, Popup, Progress, Pagination, Cell, CellGroup, RadioGroup, PullRefresh, Button, NoticeBar, Panel, Checkbox, Tabbar, TabbarItem, Divider, Notify, Dialog, Tag, DatetimePicker, ActionSheet } from 'vant';

Vue.use(Tag);
Vue.use(Col);
Vue.use(Row);
Vue.use(Cell);
Vue.use(Icon);
Vue.use(Panel);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Popup);
Vue.use(Notify);
Vue.use(Empty);
Vue.use(Button);
Vue.use(NavBar);
Vue.use(Divider);
Vue.use(Checkbox);
Vue.use(Progress);
Vue.use(NoticeBar);
Vue.use(CellGroup);
Vue.use(RadioGroup);
Vue.use(Pagination);
Vue.use(PullRefresh);
Vue.use(TabbarItem);
Vue.use(Tabbar);
Vue.use(DatetimePicker);
Vue.use(ActionSheet);
console.log(ActionSheet);

window.Toast = Toast


// WEBPACK FOOTER //
// ./src/core/use_vant.js